import PropTypes from 'prop-types'
import { FormControl, FormLabel, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { STACK_MODE_LABELS, STACK_MODES } from 'lib'

export const StackModeField = ({ value, onChange, label = 'Structure Position', size = 'sm' }) => {
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <RadioGroup value={value || STACK_MODES.Stacked} onChange={onChange}>
        <Stack direction="row" spacing={4}>
          <Radio size={size} value={STACK_MODES.Stacked}>{STACK_MODE_LABELS[STACK_MODES.Stacked]}</Radio>
          <Radio size={size} value={STACK_MODES.SideBySide}>{STACK_MODE_LABELS[STACK_MODES.SideBySide]}</Radio>
        </Stack>
      </RadioGroup>
    </FormControl>
  )
}

StackModeField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string
}
